import { useState, MouseEvent } from 'react'
import { Box, CircularProgress, Grid, Typography } from '@mui/material'
import { Button } from '@fullscreendigital/carrefour-dex-fe'
import { Modal } from 'components/core-ui/Modal'
import { Link } from 'components/core-ui/Link'
import { getDailyReportMetiReports } from 'components/waste-management/api'
import { useNotification } from 'hooks'
import s from 'components/core-ui/Modal/Modal.modules.scss'

type MetiReportsModalProps = {
  isModalOpen: boolean
  closeModal: () => void
  dailyReportId: number
}

const MetiReportsModal = ({ isModalOpen, closeModal, dailyReportId }: MetiReportsModalProps) => {
  const { showNotification } = useNotification()

  const { data: metiReports = [], isFetching } = getDailyReportMetiReports(
    showNotification,
    dailyReportId,
    isModalOpen
  )

  return (
    <Modal
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      modalTitle="Rapoarte METI"
      modalWidth="40%"
    >
      <Grid container spacing={4}>
        <Grid xs={12} item>
          {isFetching ? (
            <Box style={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress color="primary" disableShrink />
            </Box>
          ) : metiReports.length === 0 ? (
            <Typography className={s.modalMessage}>
              Nu exista rapoarte METI pentru acest raport zilnic
            </Typography>
          ) : (
            metiReports.map(report => (
              <Box key={report.id}>
                <Link href={`/wasteManagement/records/metiReports?metiReportId=${report.id}`}>
                  {report.name}
                </Link>
              </Box>
            ))
          )}
        </Grid>
        <Grid xs={12} item className={s.modalButtons}>
          <Button variant="outlined" label="Inchide" onClick={closeModal} />
        </Grid>
      </Grid>
    </Modal>
  )
}

type MetiReportsCellProps = {
  dailyReportId: number
}

export const MetiReportsCell = ({ dailyReportId }: MetiReportsCellProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <Link
        href="#"
        onClick={(event: MouseEvent<HTMLAnchorElement>) => {
          event.preventDefault()
          setIsModalOpen(true)
        }}
      >
        Vezi rapoarte
      </Link>
      <MetiReportsModal
        isModalOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
        dailyReportId={dailyReportId}
      />
    </>
  )
}

export default MetiReportsModal
